import type {
  FiltrosDeBusqueda, RegistroDePaciente, RegistroDeProfesional, RespuestaBusqueda, RespuestaCatalogos,
  RespuestaCuentasDeDemostracion, RespuestaHorarios, RespuestaMensaje, RespuestaPerfil, RespuestaRegistro, RespuestaResumen,
} from '@medchoice/shared';
import { buildQuery, request } from './client';

export const publico = {
  catalogos: () => request<RespuestaCatalogos>('/catalogos').then((r) => r.catalogos),

  resumen: () => request<RespuestaResumen>('/catalogos/resumen').then((r) => r.resumen),

  cuentasDeDemostracion: () =>
    request<RespuestaCuentasDeDemostracion>('/cuentas/demostracion').then((r) => r.cuentas),

  buscar: (filtros: FiltrosDeBusqueda) =>
    request<RespuestaBusqueda>(`/profesionales${buildQuery({ ...filtros })}`).then((r) => r.profesionales),

  perfil: (id: number) => request<RespuestaPerfil>(`/profesionales/${id}`).then((r) => r.profesional),

  horarios: (id: number, fecha: string, servicio: number) =>
    request<RespuestaHorarios>(`/profesionales/${id}/disponibilidad${buildQuery({ fecha, servicio })}`)
      .then((r) => r.horarios),

  registrarPaciente: (datos: RegistroDePaciente) =>
    request<RespuestaRegistro>('/cuentas/pacientes', { method: 'POST', body: datos }),

  registrarProfesional: (datos: RegistroDeProfesional) =>
    request<RespuestaRegistro>('/cuentas/profesionales', { method: 'POST', body: datos }),

  recuperar: (email: string) =>
    request<RespuestaMensaje>('/cuentas/recuperacion', { method: 'POST', body: { email } }),
};
